// extracted by mini-css-extract-plugin
module.exports = {"facebookComment":"facebookComment_facebookComment__245nw"};